import React from 'react'
import CodeTestBrowser from 'components/CodeTestBrowser'
import { Typography } from '@mui/material'
import Box from 'components/Box/Box'
import useStyles from './styles'

export interface IAddSampleWorkProps {
  isProfileCreationMode: boolean
}

function AddSampleWork(props: IAddSampleWorkProps) {
  const { classes } = useStyles()
  const { isProfileCreationMode } = props

  return (
    <Box className={classes.container}>
      <div>
        <CodeTestBrowser
          disabled={isProfileCreationMode}
        />

        <Typography variant="body1" className={classes.text}>
          {isProfileCreationMode && (
            <React.Fragment>
              Finish creating your profile first,
              and then share your expertise with the world to improve your profile!
            </React.Fragment>
          )}

          {!isProfileCreationMode && (
            <React.Fragment>
              Sharing past projects is a great way to share your expertise with the world and improve your profile!
            </React.Fragment>
          )}
        </Typography>
      </div>
    </Box>
  )
}

export default React.memo(AddSampleWork)
